import moment from 'moment-timezone';

const TZ = 'America/Sao_Paulo';

// Cronômetro da chamada: mm:ss, com a hora só a partir de 60 minutos.
export function formatClock(seconds) {
  const total = Math.max(Math.floor(seconds || 0), 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(rest).padStart(2, '0');
  if (hours > 0) {
    return `${hours}:${mm}:${ss}`;
  }
  return `${mm}:${ss}`;
}

// O saga guarda o `timestamp` como texto ISO e empilha a mais nova na frente.
function messageTime(message) {
  const value = message && message.timestamp;
  if (!value) {
    return 0;
  }
  const parsed = typeof value === 'number' ? value : Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
}

// O reverse garante a ordem certa também quando duas mensagens caem no mesmo
// milissegundo, já que o sort é estável.
export function sortMessages(messages) {
  return [...(messages || [])].reverse().sort((a, b) => messageTime(a) - messageTime(b));
}

export function formatMessageTime(timestamp, reference) {
  if (!timestamp) {
    return '';
  }
  const value = moment.tz(timestamp, TZ);
  const base = reference ? moment.tz(reference, TZ) : moment().tz(TZ);
  if (value.isSame(base, 'day')) {
    return value.format('HH:mm');
  }
  return value.format('DD/MM HH:mm');
}
